import type { ShippingLabelViewModel } from "@/modules/chat-tools/domain/build-shipping-label";
import { formatLabelAmount } from "@/modules/chat-tools/domain/build-shipping-label";
import { LUCK_PRINT_WIDTH_PX } from "@/modules/chat-tools/domain/luck-printer/protocol";
import { normalizeLabelWidth } from "./bitmap-to-luck-raster";

function buildTextModeLines(label: ShippingLabelViewModel): string[] {
  const lines = [
    `ຜູ້ຝາກ: ${label.senderPhone}`,
    `ຜູ້ຮັບ: ${label.recipientName}`,
    `ເບີ: ${label.recipientPhone}`,
    `ປະເພດ: ${label.categoryLabel}`,
  ];

  if (label.addressDetail) {
    lines.push(label.addressDetail);
  }

  if (label.branchName) {
    lines.push(`ສາຂາ ${label.branchName}`);
    lines.push(label.carrierName);
  } else {
    lines.push(label.carrierName);
  }

  if (label.localityLine) {
    lines.push(label.localityLine);
  }

  if (label.isCod) {
    lines.push("#ເກັບ COD");
    lines.push(`ລາຄາ: ${formatLabelAmount(label.codAmount)} ກີບ`);
    if (label.collectShippingAtDestination) {
      lines.push("(ເກັບຄ່າສົ່ງປາຍທາງ)");
    }
  }

  lines.push("ຂອບໃຈເດີ້ · Thank You");
  return lines;
}

export async function renderLabelBitmapTextMode(
  label: ShippingLabelViewModel,
  targetWidth = LUCK_PRINT_WIDTH_PX,
): Promise<ImageData> {
  const lines = buildTextModeLines(label);
  const padding = 16;
  const lineHeight = 28;
  const height = padding * 2 + lines.length * lineHeight;

  const canvas = document.createElement("canvas");
  canvas.width = targetWidth;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Canvas not supported");

  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, targetWidth, height);
  ctx.fillStyle = "#000000";
  ctx.font = "600 22px system-ui, sans-serif";
  ctx.textBaseline = "top";

  lines.forEach((line, index) => {
    const isBranch = line.startsWith("ສາຂາ ");
    ctx.font = isBranch
      ? "700 28px system-ui, sans-serif"
      : "600 22px system-ui, sans-serif";
    ctx.fillText(line, padding, padding + index * lineHeight);
  });

  return normalizeLabelWidth(ctx.getImageData(0, 0, targetWidth, height));
}

export async function renderLabelTextPreviewDataUrl(
  label: ShippingLabelViewModel,
): Promise<string> {
  const imageData = await renderLabelBitmapTextMode(label);
  const canvas = document.createElement("canvas");
  canvas.width = imageData.width;
  canvas.height = imageData.height;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Canvas not supported");
  ctx.putImageData(imageData, 0, 0);
  return canvas.toDataURL("image/png");
}
